//TODO: utilizar variavel do banco após adição desses campos - por enquanto hardcoded até definirem os valores corretos do Assist Pro
export const START_CHARGE_DATE = new Date(2025, 5, 16);
export const TRIAL_LIMIT_DATE = new Date(2025, 5, 15);
export const SUBSCRIPTION_PAGE_FEATURES = [
  "Número de telefone exclusivo.",
  "Cancele a qualquer momento.",
];
export const LEGACY_SUBSCRIPTION_PAGE_FEATURES = [
  "Seu número exclusivo continua o mesmo.",
  "Cancele a qualquer momento.",
];
